import { Business, ICurrencyRate } from "@/config";

export const setToken = (token: string) => {
    localStorage.setItem("token", token);
};

export const removeToken = () => {
    localStorage.removeItem("token");
};

export const setUser = (user: any) => {
    try {
        localStorage.setItem("user", JSON.stringify(user));
    }
    catch (error) {
        console.log(error)
    }
};

export const getUser = () => {
    try {
        const user = localStorage.getItem("user");
        return user ? JSON.parse(user) : null;
    } catch (error) {
        console.log(error)
    }
};

export const removeUser = () => {
    localStorage.removeItem("user");
};

export const setShop = (shop: Business): void => {
    try {
        localStorage.setItem("shop", JSON.stringify(shop));
    } catch (error) {
        console.error(error);
    }
};

export const getShop = (): Business | null => {
    const shop = localStorage.getItem("shop");
    return shop ? (JSON.parse(shop) as Business) : null;
};

export const getCurrencyConfig = (): ICurrencyRate | null => {
    const shop = getShop();

    return shop?.currencyBase || null;
};

export const removeShop = () => {
    localStorage.removeItem("shop");
}